import { Image, Text, View } from "@react-pdf/renderer";

const TherapistSignaturePdf = ({ therapistDetails }) => {
  return (
    <View>
      {therapistDetails?.caseTherapist?.therapist_detail?.signature_img && (
        <Image
          style={{ width: "20%", backgroundColor: "transparent", marginBottom: "5px" }}
          src={{ uri: therapistDetails?.caseTherapist?.therapist_detail?.signature_img, method: "GET", headers: { "Cache-Control": "no-cache" } }}
          cache={false}
        />
      )}
    
      <Text>
        {therapistDetails?.caseTherapist?.therapist_detail?.email_signature}
      </Text>
    </View>
  )
}

export default TherapistSignaturePdf;